import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function ServicesView() {
  useDocumentTitle('Our Services-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-12'}
        title={'Our Services'}
        link={'Our Services'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">Person Centred Planning</h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">T</span>he organization
                  aims to promote and reflect the values that focus on the
                  individual Client, as being central to care planning and
                  service delivery. We believe that Clients are best placed to
                  know what they need and how those needs can be best met. We
                  help our clients to fulfill their expectations and
                  aspirations, and we enable them to make their own plans and
                  decisions regarding their social care package.
                </p>
                <p className="values_p3">
                  Quality Health and Homecare Services work in partnership with
                  local services and professionals to promote our client’s
                  independence, dignity, choice, inclusion, and rehabilitation.
                  We also encourage clients to experience a wide range of
                  activities, by giving support in the development of social
                  contacts and relationships.
                </p>
                <p className="values_p3">
                  To achieve these outcomes, we work with each person to help
                  them develop a person-centered plan. We work with the person’s
                  wider circle, their families, Friends, advocates, and other
                  professionals to ensure the plan truly reflects their needs
                  and preferences. The plan is outcome-focused and includes
                  details of all areas of support required to meet each person’s
                  individual needs, wishes, and aspirations.
                </p>
                <p className="values_p3">
                  We ensure support plans are reviewed regularly so that they
                  continue to be appropriate and effective. This is done with
                  the involvement of the Client, their families, and other
                  professionals. The Plan will be monitored to ensure that
                  individual goals are being met and new goals being set to
                  ensure people are being helped to reach their maximum
                  potential and are accessing new opportunities.
                </p>
                <p className="values_p3">
                  For further details about our services, please do not hesitate
                  to contact us for a free non-obligatory assessment.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/our-values">
                        Our values
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/our-care">
                        Our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Personal Care</h2>
                <p className="white-color">We assist with:</p>
                <div>
                  <ul className="care_bullets">
                    <li>Washing/dressing</li>
                    <li className="">Bathing/showering</li>
                    <li>Getting up / returning to bed</li>
                    <li>Toileting</li>

                    <li>Managing incontinence</li>
                    <li>Care of skin/pressure areas</li>
                    <li>Oral hygiene</li>
                    <li>Use of hoists and transfer aids</li>
                    <li>Medication</li>
                    <li>Feeding</li>
                    <li>Catheter care</li>
                    <li>Eye and ear drops</li>
                    <li>Prompt daily tasks where appropriate</li>
                    <li>Supervision</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Domestic Care</h2>
                <p className="">
                  We also provide assistance with domestic tasks which may
                  include;
                </p>
                <div>
                  <ul className="care_bullets2">
                    <li>Laundry</li>
                    <li className="">Meal preparation</li>
                    <li>Shopping</li>
                    <li>Meal preparation</li>
                    <li>Cleaning</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Mental Health and Learning Disabilities
                </h2>
                <p className="white-color">
                  We are specialists in providing social care services for
                  Learning Disabilities and Challenging Behaviour, Borderline
                  Personality Disorder (BPD), and Dual Diagnosis (Mental Health
                  and Substance Misuse). Our services are home and community
                  based, complemented by a multi-disciplinary team comprising
                  psychologists, Activities Coordinators, Registered Mental
                  Health Nurses, Managers, Consultant psychiatrists, Dual
                  Diagnosis Specialists, Healthcare Support Workers, and Speech
                  and Language Therapists.
                </p>
                <p className="white-color">
                  Our services have typically been built up by a committed team
                  of professionals. We endeavor to achieve excellence in service
                  management because we have high aspirations. We are committed
                  to staff support and training, Client (including carers and
                  families) involvement, and partnership to achieve our goals in
                  care delivery.
                </p>
                <p className="white-color">Services Provided:</p>
                <div>
                  <ul className="care_bullets">
                    <li>
                      Support with Comprehensive Assessments including
                      individual risk assessment
                    </li>
                    <li className="">
                      Support with Engagement in Community Programmes
                    </li>
                    <li>
                      Support with attending Daily Living Skills group meetings
                    </li>
                    <li>
                      Support with accessing Art Therapy / Domestic Skills
                      Training / Music Therapy
                    </li>
                    <li>
                      Support Clients to maintain their Culture & Spiritual
                      values
                    </li>
                    <li>Support with Health Promotion</li>
                    <li>
                      {' '}
                      Signpost Clients to organizations that offer Financial
                      Management / Budgeting Skills Training / Social Skills
                      Training
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Borderline Personality Disorder</h2>
                <p className="">
                  Borderline Personality Disorder (BPD) is characterized by
                  emotional instability. Those suffering from this disorder are
                  often unclear and disturbed about their own self-image and
                  usually have chronic feelings of emptiness. They are also
                  often involved in intense and unstable relationships that may
                  cause the repeated emotional crisis. Excessive efforts to
                  avoid abandonment and frequent suicidal threats of self-harm
                  are also common in this group of clients. Most people with BPD
                  report past traumatic experiences. They often go through
                  erratic mood states which can change quickly and remain
                  intense for prolonged periods of time.
                </p>
                <p>
                  By fostering an atmosphere where employees feel free to voice
                  concerns and are supported in upholding their safeguarding
                  obligations, we ensure that every member of our staff is
                  qualified to carry out their duties for promoting and
                  safeguarding the welfare of children and
                </p>
                <p>Short-term crisis intervention (24-hour referral system)</p>
                <p>
                  A longer-term therapeutic treatment program utilizing the
                  principles of
                </p>
                <p>Dialectical Behaviour Therapy (DBT)</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Dual Diagnosis Mental Health and Substance Misuse
                </h2>
                <p className="white-color">
                  We define Dual Diagnosis as the co-existence of mental health
                  and substance misuse problems. We do recognize the need for
                  partnerships because substance misuses have myriad social
                  problems which require interventions from a range of
                  providers, hence joint working across health and social care
                  is vital for effective treatment. It is therefore very
                  important to involve Clients as active partners in their care
                  to include peer education schemes to reduce the risk of
                  overdose and blood–borne viruses.
                </p>
                <p className="white-color">Dual Diagnosis Services Provided:</p>
                <div>
                  <ul className="care_bullets">
                    <li>Support in Detoxification</li>
                    <li className="">Substitute Prescribing,</li>
                    <li>Harm Reduction</li>
                    <li>Rehabilitation Programmes</li>
                    <li>
                      Psychological Therapy (Counselling, Group Therapy, Art
                      Therapy, Dialectical Behaviour Therapy, and Drama Therapy)
                    </li>
                    <li>
                      Complementary Therapies (Auricular / Ear Acupuncture,
                      Shiatsu, and Reflexology)
                    </li>
                    <li>
                      Advisory Service / Support Service for Drugs and Alcohol
                      (Drop In or Telephone Support).
                    </li>
                  </ul>
                </div>
                <h2 className="white-color">
                  Why are we involved? Issues between health and substance
                  misuse
                </h2>
                <blockquote>
                  Dual diagnosis clients are everybody’s business, but nobody’s
                  priority. Substance misuse and mental health are two parallel
                  universes with totally different cultures and commissioning
                  practices
                </blockquote>
                <span className="white-color">Clinical Researcher</span>
                <blockquote>
                  Dual Diagnosis patients are often the bed blockers. No one
                  will take them after hospital admission. Services like housing
                  and day centers shy away. They want people who are drug-free
                </blockquote>
                <span className="white-color">
                  Registered Mental Health Nurses
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Learning Disabilities and Challenging Behaviour
                </h2>
                <p className="">
                  Learning Disability (sometimes called intellectual disability)
                  is generally described as being mild, moderate, severe, and
                  profound. Profound learning disability is a developmental
                  disability and refers to individuals who have either no speech
                  or limited communication and require support with daily living
                  skills such as dressing and eating. British Institute for
                  Learning Disability defines severely challenging behavior as:
                  “behavior of such an intensity, frequency or duration that the
                  physical safety of the person or others is likely to be placed
                  in serious jeopardy, or behavior which is likely to seriously
                  limit or delay access to and use of ordinary community
                  facilities”
                </p>
                <h2 className="compassion">
                  Our Service Model: Learning Disability and Challenging
                  Behaviour
                </h2>
                <div>
                  <ul className="care_bullets2">
                    <li>
                      We have a community-based service supported by a highly
                      skilled workforce to reduce the probability of Challenging
                      Behaviour emerging or worsening
                    </li>
                    <li className="">
                      Our services are outcome focused and would seek to
                      facilitate access to work, education, and other day
                      placements.
                    </li>
                    <li>
                      Promoting Independence, social inclusion, and choice
                      through Supported Living - in the client’s own home.
                    </li>
                    <li>
                      Well-coordinated Multi-Disciplinary Team approach backed
                      by good access to generic services including mental health
                      services
                    </li>
                    <li>
                      Our service will facilitate access to other health and
                      social services in line with Valuing People Framework
                      which states that people with learning disabilities have
                      the same right of access to mainstream health services as
                      the rest of the population.
                    </li>
                    <li>
                      Supporting people with Learning Disabilities and
                      Challenging Behaviour living with their families
                    </li>
                    <li>
                      Supporting people with Learning Disabilities and
                      Challenging Behaviour living in other accommodation
                    </li>
                  </ul>
                </div>
                <p>
                  We, therefore, believe that people with Learning disabilities
                  and Challenging Behaviour have the same needs as anyone else.
                  They should not surrender their personal relationships, for
                  growth and development or for anything else because their
                  behavior presents a challenge to services. They have the same
                  human and civil rights as anyone else.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Individual Care Package</h2>
                <p className="white-color">
                  To promote empowerment and avoid oppressive and discriminatory
                  practices, Clients are encouraged to actively participate in
                  formulating their own care plans. For those who are not able
                  to consent, a family member or advocate will be involved. We
                  see it as good practice to involve clients in the design,
                  planning, development and evaluation of our services and in
                  advocacy and support groups.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Carers & Leavers Group</h2>
                <p className="">
                  A Carer is anyone who has significant contact support with the
                  client; this includes family members, spouses/partners,
                  friends and professionals who are involved in the care of the
                  client. The families and carers of our clients are a valuable
                  resource of information and should be involved wherever
                  possible and agreed upon by the client. However, carers
                  themselves are also often in need of information hence will
                  also provide information to them about benefits, activities,
                  support groups, voluntary organizations, etc. We also provide
                  a carers group and a leavers group where those clients who
                  have left our service can come to speak about their
                  experiences.
                </p>

                <p>
                  Response to the inquiry by our management team (including a
                  comprehensive assessment of the client at no cost) to be
                  carried out by our team of care professionals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        btn1="Meet our team"
        btn2="Read our testimonials"
        link1="/team"
        link2="/testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default ServicesView;
